<div
  *ngIf="
    colVm.columnType === Types.SectionColumnProductInfoType.ProductTitle &&
    (menu | shouldInflateColumnForRow: section : colVm : rowVm)
  "
  class="product-title-container"
  [class]="additionalClasses"
  [class.first-column]="first"
  [class.last-column]="last"
  [class.default-background-color]="!(productStylingVm | columnBackgroundColor: colVm | async)"
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'"
  [style.margin-left]="menu | method: 'getSectionBorderMarginSize'">
  @let storedBadges = rowVm | getBadgesInlineWithName;
  @let strainTypeDataValue = rowVm | method: 'getStrainTypeDataValue';
  @let isStrainTypeBadge = strainTypeDataValue === Types.SectionColumnConfigDataBadgeMode.Badge;
  <div
    class="flex-container product-title-flex-container"
    [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''">
    @let strainType =
      (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.TitleLine &&
      (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationData) &&
      (rowVm | method: 'getReadableStrainType' : strainTypeDataValue);
    @let strainTypeBadge =
      (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.TitleLine &&
      (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationData) &&
      (rowVm | method: 'getStrainTypeBadge' : strainTypeDataValue);
    @let brand =
      (menu | method: 'fixedLocationBrandPropertyIsWithin') === Types.WithinNameCell.TitleLine &&
      (menu | method: 'isFixedLocationBrandPropertyCellVisible' : fixedLocationData) &&
      (rowVm | method: 'getBrand');
    @let strain =
      (menu | method: 'fixedLocationStrainPropertyIsWithin') === Types.WithinNameCell.TitleLine &&
      (menu | method: 'isFixedLocationStrainPropertyCellVisible' : fixedLocationData) &&
      (rowVm | method: 'getStrain');
    @let badges =
      (menu | method: 'fixedLocationBadgesPropertyIsWithin') === Types.WithinNameCell.TitleLine &&
      (menu | method: 'isFixedLocationBadgesPropertyCellVisible' : fixedLocationData) &&
      storedBadges;
    <div
      *ngIf="strainType && !isStrainTypeBadge"
      class="base-product-strain-type"
      [ngClass]="rowVm | method: 'getStrainTypeDataToClass' : strainTypeDataValue"
      [style.background-color]="rowVm | method: 'getStrainTypeColor'">
      {{ strainType }}
    </div>
    <div *ngIf="strainType && isStrainTypeBadge" class="base-product-strain-type product-badge">
      <div class="badge">
        <img
          appImage
          [style.height]="'100%'"
          [style.width]="'100%'"
          [asset]="strainTypeBadge"
          [reset]="reset"
          alt="badge"
          src="" />
      </div>
    </div>
    <div class="product-title" [ngClass]="(section | method: 'isHidingPrices') ? 'hide-price-font-size' : ''">
      {{ rowVm | method: 'getRowTitle' }}
    </div>
    <!-- [style.min-width]="'unset'" fixes ellipsis problems caused by default min-width of 0  -->
    <span *ngIf="brand" class="product-brand" [style.min-width]="'unset'">
      {{ brand }}
    </span>
    <span *ngIf="strain" class="product-strain" [style.min-width]="'unset'">
      {{ strain }}
    </span>
    <div *ngIf="badges?.length > 0" class="product-badge">
      <div *ngFor="let b of badges; trackBy: trackByBadgeUniqueIdentifier" class="badge">
        <img
          appImage
          [style.height]="'100%'"
          [style.width]="'100%'"
          [asset]="b.image"
          [reset]="reset"
          alt="badge"
          src="" />
      </div>
    </div>
    <app-label-inflator
      #labelInflator
      *ngIf="!calculationMode && productStylingVm?.showInlineLabelOnTitleLine$ | async"
      class="product-label-container"
      [labelComponentInterface]="rowVm"
      [checkForPriceChange]="checkForPriceChange">
    </app-label-inflator>
  </div>
  @let subtitleStrainType =
    (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getReadableStrainType' : strainTypeDataValue);
  @let subtitleStrainTypeBadge =
    (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getStrainTypeBadge' : strainTypeDataValue);
  @let subtitle = (menu | method: 'getShowProductSubtitle') && (rowVm | method: 'getProductSubtitle');
  @let subtitleBrand =
    (menu | method: 'fixedLocationBrandPropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationBrandPropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getBrand');
  @let subtitleStrain =
    (menu | method: 'fixedLocationStrainPropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationStrainPropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getStrain');
  @let subtitleLineage =
    (menu | method: 'fixedLocationLineagePropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationLineagePropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getLineage');
  @let subtitleDescription =
    (menu | method: 'fixedLocationDescriptionPropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationDescriptionPropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getProductDesc');
  @let subtitleBadges =
    (menu | method: 'fixedLocationBadgesPropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
    (menu | method: 'isFixedLocationBadgesPropertyCellVisible' : fixedLocationData) &&
    storedBadges;
  <div
    *ngIf="
      subtitleStrainType ||
      subtitle ||
      subtitleBrand ||
      subtitleStrain ||
      subtitleLineage ||
      subtitleDescription ||
      subtitleBadges?.length > 0 ||
      (productStylingVm?.showInlineLabelOnSubtitleLine$ | async)
    "
    class="flex-container subtitle-flex-container"
    [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''">
    <div
      *ngIf="subtitleStrainType && !isStrainTypeBadge"
      [style.background-color]="rowVm | method: 'getStrainTypeColor'"
      class="base-product-strain-type">
      {{ subtitleStrainType }}
    </div>
    <div *ngIf="subtitleStrainType && isStrainTypeBadge" class="product-badge">
      <div class="badge">
        <img
          appImage
          [style.height]="'100%'"
          [style.width]="'100%'"
          [asset]="subtitleStrainTypeBadge"
          [reset]="reset"
          alt="badge"
          src="" />
      </div>
    </div>
    <div
      *ngIf="subtitle"
      [style.color]="productStylingVm?.forcedRowTextColorToDisplay$ | async"
      class="product-subtitle">
      {{ subtitle }}
    </div>
    <span *ngIf="subtitleBrand" class="product-subtitle product-subtitle-brand" [style.min-width]="'unset'">
      {{ subtitleBrand }}
    </span>
    <div *ngIf="subtitleStrain" class="product-subtitle product-subtitle-strain">
      {{ subtitleStrain }}
    </div>
    <div *ngIf="subtitleLineage" class="product-subtitle product-subtitle-lineage">
      {{ subtitleLineage }}
    </div>
    <div *ngIf="subtitleDescription" class="product-subtitle product-subtitle-description">
      {{ subtitleDescription }}
    </div>
    <div *ngIf="subtitleBadges?.length > 0" class="product-badge">
      <div *ngFor="let b of storedBadges; trackBy: trackByBadgeUniqueIdentifier" class="badge">
        <img
          appImage
          [style.height]="'100%'"
          [style.width]="'100%'"
          [asset]="b.image"
          [reset]="reset"
          alt="badge"
          src="" />
      </div>
    </div>
    <app-label-inflator
      #labelInflator2
      *ngIf="!calculationMode && productStylingVm?.showInlineLabelOnSubtitleLine$ | async"
      class="product-label-container label-no-margin"
      [labelComponentInterface]="rowVm"
      [checkForPriceChange]="checkForPriceChange">
    </app-label-inflator>
  </div>
  @let belowSubtitleStrainType =
    (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.BelowSubtitleLine &&
    (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationData) &&
    (rowVm | method: 'getReadableStrainType' : colVm.strainTypeMode);
  @let belowSubtitleBadges =
    (menu | method: 'fixedLocationBadgesPropertyIsWithin') === Types.WithinNameCell.BelowSubtitleLine &&
    (menu | method: 'isFixedLocationBadgesPropertyCellVisible' : fixedLocationData) &&
    storedBadges;
  @let belowSubtitleTertiaryTitle =
    (menu | method: 'getShowProductTertiaryTitle') && (rowVm | method: 'getProductTertiaryTitle');
  <div
    *ngIf="belowSubtitleStrainType || belowSubtitleBadges?.length > 0 || belowSubtitleTertiaryTitle"
    class="flex-container under-subtitle-flex-container"
    [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''">
    <div
      *ngIf="belowSubtitleStrainType"
      [style.background-color]="rowVm | method: 'getStrainTypeColor'"
      class="base-product-strain-type">
      {{ belowSubtitleStrainType }}
    </div>
    <div *ngIf="belowSubtitleBadges?.length > 0" class="product-badge">
      <div *ngFor="let b of belowSubtitleBadges; trackBy: trackByBadgeUniqueIdentifier" class="badge">
        <img
          appImage
          [style.height]="'100%'"
          [style.width]="'100%'"
          [asset]="b.image"
          [reset]="reset"
          alt="badge"
          src="" />
      </div>
    </div>
    <div
      *ngIf="belowSubtitleTertiaryTitle"
      [style.color]="productStylingVm?.forcedRowTextColorToDisplay$ | async"
      class="product-subtitle">
      {{ belowSubtitleTertiaryTitle }}
    </div>
  </div>
</div>
